import { render, staticRenderFns } from "./personInfo.vue?vue&type=template&id=67bf8582&"
import script from "./personInfo.vue?vue&type=script&lang=js&"
export * from "./personInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports